import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=0095cc90&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=0095cc90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0095cc90",
  null
  
)

export default component.exports